import React from "react";
import styled from "styled-components";
import { func, string } from "prop-types";
import ErrorMessage from "components/onboarding/components/OnboardingErrorMessage";

const StyledInput = styled.input`
  background: none;
  border: 2px solid
    ${({ error, theme }) =>
      error ? theme.colors.statusRed : theme.colors.grey};
  border-radius: 5px;
  font-size: 0.8rem;
  padding: 10px;
  margin: 5px 0;
  color: ${props => props.theme.colors.darkBlue};
  line-height: initial;
  min-width: 250px;
  width: ${({ width }) => width};

  &::placeholder {
    color: ${props => props.theme.colors.midGrey};
  }

  &:active,
  &:focus,
  &:visited {
    background: none;
    border: 2px solid ${({ theme }) => theme.colors.grey};
  }
`;

const OnboardingInput = ({
  className,
  error,
  name,
  onBlur,
  onChange,
  placeholder,
  type,
  validation,
  value,
  width
}) => {
  return (
    <div>
      <StyledInput
        className={className}
        error={error}
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        placeholder={placeholder}
        type={type}
        validation={validation}
        value={value}
        width={width}
      />
      {error && <ErrorMessage error={error} />}
    </div>
  );
};

OnboardingInput.propTypes = {
  className: string,
  error: string,
  name: string,
  onBlur: func,
  onChange: func.isRequired,
  placeholder: string,
  type: string,
  validation: func,
  value: string,
  width: string
};

export default OnboardingInput;
